import { NavLink } from "react-router-dom";
import { Home, Search, Compass, Library, Heart } from "lucide-react";
import { useI18n } from "@/context/I18n";

/**
 * Bottom tab bar for phones. The sidebar is desktop only, so without this
 * there is no way to move around on a small screen. It sits directly above
 * the player, which is fixed to the bottom.
 */
const TABS = [
  { to: "/app", end: true, icon: Home, key: "nav_home", testId: "mnav-home" },
  { to: "/app/search", icon: Search, key: "nav_search", testId: "mnav-search" },
  { to: "/app/browse", icon: Compass, key: "nav_browse", testId: "mnav-browse" },
  { to: "/app/liked", icon: Heart, key: "nav_liked", testId: "mnav-liked" },
  { to: "/app/library", icon: Library, key: "nav_library", testId: "mnav-library" },
];

export default function MobileNav() {
  const { t } = useI18n();

  return (
    <nav
      data-testid="mobile-nav"
      className="md:hidden fixed bottom-0 left-0 right-0 z-[60] h-[62px] bg-[#0d0d10] border-t border-white/10 flex items-stretch pb-[env(safe-area-inset-bottom)]"
    >
      {TABS.map(({ to, end, icon: Icon, key, testId }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          data-testid={testId}
          className={({ isActive }) =>
            `flex-1 flex flex-col items-center justify-center gap-1 text-[10px] font-medium transition-colors ${
              isActive ? "text-[#FF2A4D]" : "text-zinc-500 hover:text-white"
            }`
          }
        >
          <Icon className="w-5 h-5" />
          <span className="truncate max-w-full px-1">{t(key)}</span>
        </NavLink>
      ))}
    </nav>
  );
}
